module.exports = __webpack_public_path__ + "static/media/majorD6.071e528.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorD6.wav
// module id = OgLN
// module chunks = 0